/**
 * @file This file is not intended to be manually updated, but is automatically updated by build scripts.
 */
/**
 * The current version of the inapp-feedback-loader.
 *
 * This is dynamically updated at build time based on the content of package.json.
 */
export var IN_APP_FEEDBACK_LOADER_VERSION = '4.12.0';
